import React, {useContext, useEffect, useRef, useState} from "react"

import Button from "../../../../common/Button";
import {api} from "../../../../../api/api";
import PhoneInsertField from "../../PhoneInput";
import {getErrorByStatus, prepPhone, storeState} from "../../helpers";
import TranslationContext from "../../../../../context/TranslationContext";
import UserContext from "../../../../../context/UserContext";
import HotspotContext from "../../../../../context/HotspotContext";

const Call800Action = ({setAccess, handlerBackBtn, userPhone = ""}) => {
    const {getTranslation} = useContext(TranslationContext)
    const {setApiWait} = useContext(UserContext)
    const {request} = useContext(HotspotContext)
    const [phone, setPhone] = useState(userPhone)
    const [error, setError] = useState("")
    const [errMessage, setErrorMsg] = useState("")

    const [call800Gate, setCall800Gate] = useState("")
    const [call800GateFetch, setCall800GateFetch] = useState(false)


    const specialBackBtn = () => {
        localStorage.removeItem("_wh_call")
        handlerBackBtn()
    }

    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {setErrorMsg(getTranslation(error))} else {setErrorMsg(error)}  
        }
    },[getTranslation, error])

    useEffect(() => {
        if (localStorage.getItem("_wh_call") !== null) {
            const data = JSON.parse(localStorage.getItem("_wh_call"))
            if (data.expire < Date.now()/1000) {
                if (data.mac === request.Mac) {
                    setPhone(parseInt(data.number))
                    storeState("user_phone", data.number)
                    setCall800Gate(data.gate)
                    setCall800GateFetch(true)
                    checkCall()
                }
            }
        }

        if (userPhone) {
            setPhone(userPhone)
            call800GetGate()
        }
    }, [])
    // console.log("phone ", phone)
    const call800GetGate = () => {
        const regex = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/

        if (phone === "") {
            setError("no_num")
        } else if (!regex.test(phone)) {
            setError("wrong_num")
        } else {
            storeState("user_phone", phone)
            setApiWait(true)
            api.getGate800(phone).then(res => {
                    try {
                        prepPhone(res.data.gate)
                        setCall800Gate(res.data.gate)
                        setCall800GateFetch(true)
                        setError("")
                        localStorage.setItem("_wh_call", JSON.stringify({mac: request.Mac, nasid: request.Nasid, number: phone, gate:res.data.gate, type:800, expire: Date.now()/1000 + 300}))
                    } catch (e) {
                        setError("Ошибка получения шлюза дозвона")
                        return
                    }
            }).catch(err => {
                getErrorByStatus(err.response.status, setError, getTranslation)
            }).finally(() => setApiWait(false))
        }
    }
    
    const checkCall = () => {
        setApiWait(true)
        api.getCheckCallAuth().then(res => {
            if (res.data.status === "ok") {
                setAccess(true)
                localStorage.removeItem("_wh_call")
            } else {
                setError("call_not_found")
            }
        }).catch(err => {
            getErrorByStatus(err.response.status, setError, getTranslation)
        }).finally(()=>setApiWait(false))
    }


    return <>
        <span>{getTranslation("no_num")}</span>
        <PhoneInsertField
            value={phone}
            phoneSetter={setPhone}
            turnOffStatus={call800GateFetch}

        />
        {
            error !== "" && <p id="error">{errMessage}</p>
        }
        {
            call800GateFetch
                ? <>
                    <Button idPhrase={"back"} onClick={specialBackBtn}/>
                    <span>{getTranslation("mess_call1")}</span>
                    <a href={`tel:+${call800Gate}`} className="btn element-border">+{prepPhone(call800Gate)}</a>
                    <span>{getTranslation("mess_call2")}</span>
                    <span style={{marginBottom: "10px"}}>{getTranslation("mess_comment")}</span>
                    <Button idPhrase="call_end" onClick={checkCall}/>
                </>
                : <>
                    <Button className="mt-2"
                    idPhrase={"next"} onClick={call800GetGate}/>
                    <Button idPhrase={"back"} onClick={specialBackBtn}/>
                </>
        }
    </>
}

export default Call800Action